<template>
   <form action="" method="get">
    <div class="dropdown ms-2">
        <div class="d-none d-lg-block">
            <div class="input-group input-group-merge input-group-borderless input-group-hover-light navbar-input-group">
                <div class="input-group-prepend input-group-text">
                    <i class="bi-search"></i>
                </div>

                <!-- <input name="q" type="search" class="js-form-search form-control" placeholder="Rechercher une plainte"
                    aria-label="Rechercher une plainte"
                    data-hs-form-search-options='{
                       "clearIcon": "#clearSearchResultsIcon",
                       "dropMenuElement": "#searchDropdownMenu",
                       "dropMenuOffset": 20,
                       "toggleIconOnFocus": true,
                       "activeClass": "focus"
                     }'> -->

                <a class="input-group-append input-group-text" href="javascript:;">
                    <i id="clearSearchResultsIcon" class="bi-x-lg" style=""></i>
                </a>
            </div>
        </div>

        <button
            class="js-form-search js-form-search-mobile-toggle btn btn-ghost-secondary btn-icon rounded-circle d-lg-none"
            type="button"
            data-hs-form-search-options='{
                       "clearIcon": "#clearSearchResultsIcon",
                       "dropMenuElement": "#searchDropdownMenu",
                       "dropMenuOffset": 20,
                       "toggleIconOnFocus": true,
                       "activeClass": "focus"
                     }'>
            <i class="bi-search"></i>
        </button>
    </div>
</form>
</template>
<script>
export default{

}
</script>